var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCardApproved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 204,
    viewBox: "0 0 280 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5322 55.5425C52.5322 45.8443 60.4369 37.9579 70.1351 37.9579H210.213C219.911 37.9579 227.821 45.8443 227.821 55.5425V94.2889L227.821 102.334C226.297 102.07 224.729 101.932 223.13 101.932C222.606 101.932 222.086 101.947 221.569 101.976V97.4036H58.7845L58.7849 148.429C58.7849 154.772 63.7924 159.78 70.1355 159.78H210.212C213.553 159.78 216.526 158.39 218.591 156.148C220.067 156.395 221.583 156.523 223.13 156.523C224.07 156.523 224.999 156.476 225.914 156.383C223.001 162.102 217.051 166.033 210.211 166.033H70.1351C60.4369 166.033 52.5322 158.128 52.5322 148.43V55.5425ZM210.211 44.2102H70.1351H70.1347C63.7917 44.2102 58.7842 49.1995 58.7842 55.5425V69.3172H221.569V55.5425C221.569 49.1995 216.554 44.2102 210.211 44.2102ZM221.569 75.5749H58.7845V91.1513H221.569V75.5749ZM75.6587 118.925C76.2602 118.338 77.0725 118.017 77.914 118.035H117.257C118.957 118.072 120.315 119.461 120.315 121.161C120.315 122.861 118.957 124.249 117.257 124.287H77.914C77.0725 124.307 76.2602 123.984 75.6587 123.397C75.0572 122.808 74.7181 122.002 74.7181 121.161C74.7181 120.319 75.0572 119.514 75.6587 118.925ZM75.6587 135.82C76.2602 135.231 77.0725 134.91 77.914 134.93H94.717C95.5585 134.91 96.3707 135.231 96.9723 135.82C97.5737 136.408 97.9129 137.214 97.9129 138.056C97.9129 138.898 97.5738 139.703 96.9723 140.292C96.3707 140.879 95.5585 141.2 94.717 141.182H77.914C77.0725 141.2 76.2602 140.879 75.6587 140.292C75.0572 139.703 74.7181 138.898 74.7181 138.056C74.7181 137.214 75.0572 136.408 75.6587 135.82Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.365 121.551L219.291 135.625L212.894 129.228",
    stroke: "currentColor",
    strokeWidth: 5.11792,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 198.393,
    y: 104.491,
    width: 49.4732,
    height: 49.4732,
    rx: 24.7366,
    stroke: "currentColor",
    strokeWidth: 5.11792
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardApproved);
export default __webpack_public_path__ + "static/media/credit-card-approved.2ca7ec6ade247a1481c01098b8cefedd.svg";
export { ForwardRef as ReactComponent };